import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", {
                    session_id: sessionId,
                });
                setUser(data);
                window.history.replaceState({}, document.title, "/dashboard");
                navigate("/dashboard", { replace: true, state: { user: data } });
            } catch (err) {
                navigate("/login?error=google", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-ivory">
            <div data-testid="oauth-loader" className="eyebrow text-maroon">
                Welcoming you to the Gurukula…
            </div>
        </div>
    );
}
